import React, { useState, useEffect } from 'react';
import { FunnelState, Step } from './types';
import Landing from './components/Landing';
import Quiz from './components/Quiz';
import Analysis from './components/Analysis';
import SalesPage from './components/SalesPage';
import { tracking } from './services/tracking';

const App: React.FC = () => {
  const [funnelState, setFunnelState] = useState<FunnelState>({
    currentStep: 'landing',
    answers: [],
  });

  useEffect(() => {
    tracking.initSession();
  }, []);

  const handleStartQuiz = () => {
    setFunnelState(prev => ({ ...prev, currentStep: 'quiz' }));
    window.scrollTo(0, 0);
  };

  const handleQuizComplete = (answers: number[]) => {
    setFunnelState(prev => ({ ...prev, answers, currentStep: 'analyzing' }));
    window.scrollTo(0, 0);
  };

  const handleAnalysisComplete = () => {
    setFunnelState(prev => ({ ...prev, currentStep: 'sales' }));
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-brand-dark text-white selection:bg-brand-neon selection:text-brand-dark overflow-x-hidden">
      {/* Dynamic Header/Progress Indicator could go here */}

      <main className="w-full">
        {funnelState.currentStep === 'landing' && (
          <Landing onStart={handleStartQuiz} />
        )}

        {funnelState.currentStep === 'quiz' && (
          <Quiz onComplete={handleQuizComplete} />
        )}

        {funnelState.currentStep === 'analyzing' && (
          <Analysis onComplete={handleAnalysisComplete} />
        )}

        {funnelState.currentStep === 'sales' && (
          <SalesPage answers={funnelState.answers} />
        )}
      </main>

      <footer className="py-8 text-center text-slate-600 text-xs border-t border-slate-900 mt-auto">
        <p>© 2026 Genesis Grid AI Labs. Todos os direitos reservados.</p>
        <p className="mt-2">Este site não é afiliado ao Facebook ou Google.</p>
      </footer>
    </div>
  );
};

export default App;